export function getValueFromComputedStyle(computedStyle: CSSStyleDeclaration, key: keyof CSSStyleDeclaration): number {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Math.round(parseFloat(computedStyle[key as any]) || 0);
}
